"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEnumItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const FormItemTemplate_1 = require("../FormItemTemplate");
const FormEnumItem = ({ value, options, nullable, ...props }) => {
    // const [field, meta, helpers] = useField(props.name);
    //
    //
    //
    // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const dateVal = new Date(e.target.value);
    //     helpers.setValue(isNaN(dateVal.getTime()) ? undefined : dateVal, false);
    // }
    //
    // const actualValue = value ?? field.value;
    //
    // const valueDate = actualValue ? dateToString(actualValue) : "";
    // const readableValue = actualValue ? formattedDate(actualValue) : undefined;
    // const handleChange  = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     helpers.setValue(e.target.value);
    // }
    const [fieldsProps, _, helpers] = (0, formik_1.useField)(props.name);
    const handleChange = (e) => {
        helpers.setValue(e.target.value);
    };
    // const handleChange  = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    //     helpers.setValue(e.target.value);
    // }
    const optionItems = (0, react_1.useMemo)(() => {
        const improvedOptions = nullable ? [null, ...options] : options;
        return improvedOptions.map((item) => {
            if (item === null) {
                return {
                    value: null,
                    label: props.required ? 'Vyberte možnost' : 'Nezvoleno',
                };
            }
            else if (typeof item === "object") {
                return item;
            }
            else {
                return {
                    value: item,
                    label: item,
                };
            }
        });
    }, [options, nullable]);
    const currentValue = fieldsProps.value?.toString?.() ?? "";
    const activeItem = optionItems.find(item => (item.value?.toString?.() ?? "") === currentValue);
    const readableValue = activeItem ? (activeItem.value !== null && activeItem.value !== undefined ? activeItem.label : "") : fieldsProps.value?.toString() ?? "";
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(FormItemTemplate_1.FormItemTemplate, { ...props, value: readableValue, renderEdit: (0, jsx_runtime_1.jsx)("select", { value: fieldsProps.value, onChange: handleChange, className: "form-select", "aria-label": "Vyberte", onBlur: fieldsProps.onBlur, children: optionItems.map(item => ((0, jsx_runtime_1.jsx)("option", { value: item.value?.toString?.() ?? "", dangerouslySetInnerHTML: { __html: item.label } }, item.value))) }) }) }));
};
exports.FormEnumItem = FormEnumItem;
